export interface Attachment {
  s3FileName: string;
  userFilename: string;
}

export class OrderJSON {
  'contractRegenerate': boolean = true;
  'RSM': string = '';
  'RVP': string = '';
  'Guid': string = '';
  'byoe': boolean = false;
  'flow': string = '';
  'step': number = 0;
  'orgId': number = 0;
  'action': string = '';
  'isNRSPay': boolean = false;
  'nrsPay': boolean = false;
  'status': string = '';
  'subscriptionType': string = '';
  'TaxInfo': TaxInfo;
  'agentId': number = 0;
  'compasAgentId': number = 0;
  'orgName': string = '';
  'proceed': string = '';
  'Contacts': Contacts[];
  'NoteInfo': NoteInfo[];
  'UserInfo': UserInfo;
  'bundleId': number;
  'salesRep': string = '';
  'ElmerInfo': string = '';
  'StoreInfo': StoreInfo;
  'invoiceDt': string = '';
  'orderDate': string = '';
  'orderType': string = '';
  'productId': number;
  'BundleInfo': BundleInfo[];
  'acornOrder': string = '';
  'agentEmail': string = '';
  'agent_Name': string = '';
  'agent_type': string = '';
  'documentId': string = '';
  'postToZoho': boolean = false;
  'terminalId': number;
  'HomeAddress': HomeAddress;
  'PaymentInfo': PaymentInfo;
  'billingDate': string = '';
  'browserInfo': browserInfo;
  'installDate': string = '';
  'invoiceType': string = '';
  'marketplace': string = '';
  'orderInfoId': number;
  'loginRolePrivilegeId': number;
  'orderStatus': number;
  'processName': string = '';
  'CustomerInfo': CustomerInfo;
  'cashCheckFee': number;
  'documentCode': string = '';
  'statusUpdate': string = '';
  'terminalInfo': TerminalInfo[];
  'zohoRecordId': string = '';
  'zohoEncryptedId': string = '';
  'PromotionInfo' : PromotionInfo[];
  'agent_company': string = '';
  'invoiceAmount': Float32Array;
  'invoiceStatus': string = '';
  'isTaxOverride': boolean = false;
  'mobileConsent' = null;
  'noOfTerminals': number;
  'scheduledDate': string = '';
  'BillingAddress': BillingAddress;
  'MRCtaxesYearly': number;
  'addNewTerminal': boolean = false;
  'additionalInfo': [];
  'arApprovalDate': string = '';
  'newOrderStatus': number;
  'totalBasePrice': number;
  'totalSalePrice': string = '';
  'unifiedOrderId': string = '';
  'BillingItemInfo': BillingItemInfo[];
  'MRCtaxesMonthly': number;
  'PaymentPlanInfo': PaymentPlanInfo[];
  'ShippingAddress': ShippingAddress;
  'account_manager': {};
  'customerOrderId': number;
  'customerStoreId': number;
  'invoiceFileName': string = '';
  'regenerateOrder': boolean = false;
  'createCreditMemo': boolean = false;
  'replacementElmer': number;
  'transExternalRef': string = '';
  'billingCustomerId': number;
  'customerInvoiceId': number;
  'isTaxAmountManual': boolean = false;
  'totalPriceWithTax': number;
  'transactionAmount': number;
  'transactionStatus': string = '';
  'transactionsExist': string = '';
  'additionalDiscount': {};
  'orderDisplayStatus': string = '';
  'processorPaymentId': {};
  'accountManagerEmail': {};
  'processorCustomerId': string = '';
  'terminalReplacement': boolean = false;
  'cashCheckBillingItem': cashCheckBillingItem;
  'initialPaymentAmount': string = '';
  'PaymentInstrumentInfo': PaymentInstrumentInfo[];
  'bankDetailsInfo': bankDetailsInfo;
  'customerPaymentPlanId': number;
  'customerTransactionId': number;
  'recurringAmountYearly': number;
  'recurringAmountMonthly': number;
  'creditMemoBillingItemId': string = '';
  'skipContractRegeneration': boolean = false;
  'paymentProcessor': string = '';
  'preferredTrainingLanguage': string = '';
  'processorPaymentAccountId': string = '';
  'invoiceCustomerPaymentPlanId': number;
  'BusinessCapacity': BusinessCapacity;
  'EbtAcceptance': EbtAcceptance;
  // Legacy single-file field; new flows use business_license_names only.
  'business_license_name'?: string;
  'business_license_names': string[] = [];
  'Attachments': Attachment[] = [];
  'subType': string = '';
  'voidCheck': string = '';
  'SSN': string = '';
  'pricingPlan': string = '';
  'featuresCodes': string[] = [];
  'isNRSPAYServiceAgrementSigned': boolean = false;
  'isPlatFormServiceAgrementSigned': boolean = false;
  'nrsPAYServiceAgrementSignedRequestId': string = '';
  'SaleRepChecklist': SaleRepChecklist;
  'isNonPosToPosTerminal': boolean = false;
  'setHomeAddressTo': string = '';
  'isCustomerHomeAddressUpdated': boolean = false;
  'areBundlesAvailable':boolean=false;
  'clientIp':string='';
  'selectedEwicItems':string[]=[];
  termSelections?: { [key: string]: string };
  selectedFeaturesByCategory?: { [category: string]: number[] } = {};
  'isPersonalInfoComplete': boolean|null = null;
  'maxVisitedStepIndex': number = -1;
  'maxVisitedStepFlow': string = '';
}
export class TaxInfo {
  'taxes': Taxes[];
  'totalTax': Float32Array;
  'documentId': string = '';
}

export class Taxes {
  'tm': number;
  'cat': string = '';
  'cid': number;
  'exm': number;
  'lns': number;
  'lvl': number;
  'min': number;
  'pcd': number;
  'sur': boolean = false;
  'tax': Float32Array;
  'tid': number;
  'calc': number;
  'cmpl': boolean = false;
  'name': string = '';
  'rate': Float32Array;
  'bill': boolean = false;
}

export class Contacts {
  'Type'?: string = '';
  'Email'?: string = '';
  'Phone'?: string = '';
  'Company'?: string = '';
  'LastName'?: string = '';
  'FirstName'?: string = '';
  'ExternalID'?: number;
  'orderContactId'?: number;
}

export class NoteInfo {
  'note': string = '';
  'user': string = '';
  'note_type': string = '';
}

export class UserInfo {
  'name': string = '';
  'email': string = '';
}

export class StoreInfo {
  'mid': string;
  'email': string = '';
  'emailUpdateSelected': boolean;
  'phone': string = '';
  'currency': string = '';
  'storeName': string = '';
  'DbaAddress': DbaAddress;
  'currentPos': string = '';
  'mobilePhone': string = '';
  'StoreAddress': StoreAddress;
  'onlineSource': string = '';
  'numberOfItems': string = '';
  'typeOfMachine' = null;
  'availablePorts': string = '';
  'dbaSameAsLegal': boolean = true;
  'kindOfBusiness': string = '';
  'typeOfBusiness': string = '';
  'GeocodedAddress': GeocodedAddress;
  'customerStoreId' = null;
  'doingBusinessAs': string = '';
  'monthlyGrossSales': {};
  'paperRollsPerWeek': {};
  'resaleCertificate': {};
  'acceptsCreditCards': string = '';
  'creditCardProcessor': {};
  'posPhysicalLocation': {};
  'specialInstructions': {};
  'dbaAddressSameAsLegal': boolean = false;
  'internetConnectionType': string = '';
  'inventoryDatabaseExists': string = '';
  'webSite': string = '';
  'billingAddressSameasLegalAddress': boolean = false;
  'squareFootage' = null;
   'type': string=''
}

export class GeocodedAddress {
  'city': string = '';
  'state': string = '';
  'county': string = '';
  'country': string = '';
  'placeId': string = '';
  'lattitude': string = '';
  'longitude': string = '';
  'singleLine': string = '';
}

export class DbaAddress {
  'zip': string = '';
  'city': string = '';
  'state': string = '';
  'country': string = '';
  'address1': string = '';
  'address2' = null;
  'phone': string = '';
  'phoneUpdateSelected': boolean;
}

export class StoreAddress {
  'zip': string = '';
  'city': string = '';
  'state': string = '';
  'country': string = '';
  'address1': string = '';
  'address2' = null;
  'phone': string = '';
  'phoneUpdateSelected': boolean = false;
}

export class BundleInfo {
  'name': string = '';
  'type': string = '';
  'status': string = '';
  'bundleId': number;
  'productId': number;
  'contractTerm': number;
  'cancellationFee': string = '';
  'customerBundleId': number;
  'bundleDescription': string = '';
  'associatedBundleIds': [];
  'term': number;
  'items': Items[];
  'priceOptions': {};
  'excludedBundleIds': string = '';
  'paymentInstrumentId': number;
  'transactionFee': string;
  'threshold': string;
  'price': string;
  'invoicePrice': string;
  'suite': string;
  'promotionCode': string;
  'unselectedSoftwareBundleId': number;
}

export class Items {
  'term': number;
  'feature': string = '';
  'description': string = '';
  'item_prefix': string = '';
  'availability': string = '';
  'billing_type': string = '';
  'contact_email': string = '';
  'default_price': string = '';
  'terminal_item': string = '';
  'billing_item_id': number;
  'charge_at_level': string = '';
  'external_ref_id': number;
  'tax_service_type': string = '';
  'external_ref_code': string = '';
  'quantity_override': string = '';
  'available_at_signup': string = '';
  'capture_external_id': boolean = false;
  'tax_transaction_type': string = '';
  'inventory_item_ref_id': string = '';
  'excluded_billing_item_ids': string = '';
  'additional_packing_list_item': string = '';
  'associated_feature_billing_item_ids': string = '';
  'associated_hardware_billing_item_id': string = '';
  'replacement_hardware_billing_item_id': number;
  'planId': number;
  'bundle_id': number;
  'promotion_id': string = '';
  'promo_discount_price': string = '';
  'payment_instrument_id': number;
}

export class HomeAddress {
  'zip' = null;
  'city' = null;
  'state' = null;
  'country' = null;
  'address1' = null;
  'address2' = null;
}

export class PaymentInfo {
  'transactionTypeId': number;
  'paymentProcessorReference': string = '';
}

export class browserInfo {
  'browserName': string = '';
  'fullVersion': string = '';
  'majorVersion': number;
}

export class CustomerInfo {
  'email': string = '';
  'emailUpdateSelected': boolean;
  'phone': string = '';
  'phoneUpdateSelected': boolean;
  'title' = null;
  'brAcct' = null;
  'oasisId' = null;
  'lastName': string = '';
  'CustomerClass': string = '';
  'customerClass' = null;
  'ofaCustomerId' = null;
  'CustomerCategory': string = '';
  'customerCategory' = null;
  'resaleCertificate' = null;
  'paymentProcessorReference': string = '';
  //'dob' = null;
  'address1' = null;
  'address2' = null;
  'zipCode' = null;
  'state' = null;
  'city' = null;
  'country' = null;
  'firstName': string = '';
  'middleName' = null;
  'businessType' = null;
  'federalTaxId': string = '';
  'password': string = '';
}

export class TerminalInfo {
  'discount': string = '';
  'posTaxes': string = '';
  'basePrice': string = '';
  'priceAfterDis': number;
  'terminalPrice': number;
  'numberOfPosNeeded': number;
  'priceAfterDiscount': number;
}

export class PromotionInfo {
  'term': number;
  'amount': number;
  'applied': boolean = false;
  'quantity': string;
  'billingId': number;
  'description': string;
  'effectiveDt': Date;
  'promotionId': number;
  'expirationDt': Date;
  'salesChannel': string;
  'applicableFor': string;
  'promotionCode': string;
  'promotionType': string;
  'numberOfCycles': string;
  'promotionMethod': string;
  'appliedBundleIds': string;
  'isAdditionalItem': boolean = false;
  'promoBillingItems': PromoBillingItems[];
  'appliedPromotionId': number;
  'associateBundleIds': string;
  'screenName':string;
  'isVisibleOnEQS':boolean=true;
  'isDefaultPromo':boolean=false;
}

export class BillingAddress {
  'zip': string = '';
  'city': string = '';
  'state': string = '';
  'country': string = '';
  'address1': string = '';
  'address2' = null;
}

export class BillingItemInfo {
  'price': number;
  'displayPrice': number;
  'itemType': string = '';
  'quantity': number;
  'billingType': string = '';
  'description': string = '';
  'billingItemId': number;
  'paymentPlanId': number;
  'customerBillingItemId': number;
  'customerPaymentPlanId': number;
  'tax': string = '';
  'bundleId': number|null;
  'itemPrefix': string = '';
  'invoicePrice': number ;
  'terminalItem': string = '';
  'originalPrice': number;
  'taxServiceType': string = '';
  'externalRefCode': string = '';
  'customerBundleId': number;
  'inventoryItemRefId': string = '';
  'taxTransactionType': string = '';
  'associatedFeatureBillingItemIds': {};
  'replacementHardwareBillingItemId': number;
  'additionalItem': string = '';
  'feature': string = '';
  'freeTrial': boolean = false;
  'request':boolean=false;
  'contactEmail': string = '';
  'chargeAtLevel': string = '';
  'billingItemPriceOptionId': string = '';
  'term': number;
  'suite': string;
  'promotionCode': string;
  'screenName': string;
  'transactionFee': string;
  'category': string;
}

export class PaymentPlanInfo {
  'term': number;
  'type': string = '';
  'noofPOS': number;
  'interval': number;
  'planName': string = '';
  'isDisable': boolean = false;
  'monthlyPlan': string = '';
  'paymentPlanId': number;
  'showTermsFlag': boolean = false;
  'recurringAmount': string = '';
  'hardwareSalePlan': string = '';
  'initialPaymentAmount': number;
  'customerPaymentPlanId': number;
  'additionalEquipmentAllowed': string = '';
  'billingItemIds': number[] | null;
  'customDownPaymentAmt': number;
}

export class ShippingAddress {
  'zip' = null;
  'city' = null;
  'state' = null;
  'country' = null;
  'address1' = null;
  'address2' = null;
}

export class cashCheckBillingItem {
  'status': string = '';
  'feature': string = '';
  'mrc_item': string = '';
  'petro_item': {};
  'description': string = '';
  'item_prefix': {};
  'resale_item': string = '';
  'billing_type': string = '';
  'contact_email': {};
  'default_price': number;
  'hardware_item': string = '';
  'terminal_item': string = '';
  'warranty_item': string = '';
  'billing_item_id': number;
  'billing_options': {};
  'charge_at_level': string = '';
  'external_ref_id': number;
  'warranty_period': {};
  'applied_promo_id': number;
  'tax_service_type': string = '';
  'external_ref_code': string = '';
  'display_in_invoice': string = '';
  'available_at_signup': string = '';
  'capture_external_id': boolean = false;
  'manageable_from_pos': boolean = false;
  'tax_transaction_type': string = '';
  'inventory_item_ref_id': {};
  'excluded_billing_item_ids': {};
  'additional_packing_list_item': string = '';
  'associated_feature_billing_item_ids': {};
  'associated_hardware_billing_item_id': {};
  'replacement_hardware_billing_item_id': {};
}

export class PaymentInstrumentInfo {
  'type': string = '';
  'usage': string = '';
  'status': string = '';
  'bracct': string|null = '';
  'issuer': string = '';
  'applied': boolean;
  'initial': boolean;
  'appliesTo': string = '';
  'chkNumber': string = '';
  'recurring': boolean|null;
  'achBankName': string = '';
  'chkBankName': string = '';
  'nameOnAccount': string = '';
  'paymentPlanId': number | null;
  'achAccountType': string = '';
  'expirationDate': string = '';
  'achInstitutionNumber': string = '';
  'achAccountNumber': string = '';
  'achRoutingNumber': string = '';
  'chkAccountNumber': string = '';
  'chkRoutingNumber': string = '';
  'creditCardNumber': string = '';
  'paymentMethodSet': boolean = false;
  'paymentMethodCode': string = '';
  'referenceFileName': string = '';
  'referenceFileType': string = '';
  'transactionTypeId': number;
  'paymentDescription': string = '';
  'paymentMethodTypeId': number;
  'processorSetupIntent': string = '';
  'replcementPaymentMethod': string = '';
  'paymentProcessorReference': string = '';
  'receiptsBankAccountNumber': string = '';
  'customerPaymentInstrumentId': number;
  'id': number;
  'billingItemIds': null|number[];
  'softwareBundleIds': number[];
  'paymentMethodNewlyAdded': boolean = false;
  'PaymentChargesType': string = '';
  'useForHardwareItems': boolean|null = false;
  'useForRecurringItems': boolean|null = false;
}

export class bankDetailsInfo {
  'type': string = '';
  'usage': string = '';
  'status': string = '';
  'bracct': string = '';
  'issuer': string = '';
  'applied': boolean = false;
  'initial': boolean = false;
  'appliesTo': string = '';
  'chkNumber': string = '';
  'recurring': boolean = false;
  'achBankName': string = '';
  'chkBankName': string = '';
  'nameOnAccount': string = '';
  'paymentPlanId': number;
  'achAccountType': string = '';
  'expirationDate': string = '';
  'achInstitutionNumber': string = '';
  'achAccountNumber': string = '';
  'achRoutingNumber': string = '';
  'chkAccountNumber': string = '';
  'chkRoutingNumber': string = '';
  'creditCardNumber': string = '';
  'paymentMethodSet': boolean = false;
  'paymentMethodCode': string = '';
  'referenceFileName': string = '';
  'referenceFileType': string = '';
  'transactionTypeId': number;
  'paymentDescription': string = '';
  'paymentMethodTypeId': number;
  'processorSetupIntent': string = '';
  'replcementPaymentMethod': string = '';
  'paymentProcessorReference': string = '';
  'receiptsBankAccountNumber': string = '';
  'customerPaymentInstrumentId': number;
  'id': number;
  'billingItemIds': number[];
  'softwareBundleIds': number[];
  'paymentMethodNewlyAdded': boolean = false;
  'bankDetailsFromZoho': boolean = false;
  'PaymentChargesType': string = '';
  'useForHardwareItems': boolean = false;
}

export class BusinessCapacity {
  'monthlyCreditCardCharges': string = '';
  'avgCreditCardTransactionAmount': string = '';
  'highestCreditCardTransactionAmount': string = '';
  'projectedYearlyStoreSales': string = '';
  'businessEstablished': string = '';
  'ownership': string = '';
  'noOfTimesPerYear': string = '';
  'businessYears': string = '';
  'businessMonths': string = '';
  'mcc': string = '';
}

export interface EbtAcceptance {
  ebt: boolean;
  ebtNumber: number;
  signUpForEBT: boolean;
  ewic: boolean;
  ewicNumber: number;
  signUpForEWIC: boolean;
  rapidFunding: boolean;
  note: string;
}

export class SaleRepChecklist {
  'nrsPurplePayroll': string = '';
}
export class PromoBillingItems{
  'billing_item_id':number;
  'price': number;
  'promotion_id':number;
  'term':number;


}
